import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  stats: {},
  stat: null,
  selectedVenue: "All",
  selectedSeriesData: "Today",
  selectedTopSellingSeries: "Today",
  topSellingStats: {},
};

const statSlice = createSlice({
  name: "stat",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getStatsSuccess(state, action) {
      state.isLoading = false;
      state.stats = action.payload;
    },
    getTopSellingStatsSuccess(state, action) {
      state.isLoading = false;
      state.topSellingStats = action.payload;
    },
    setSelectedVenue(state, action) {
      state.selectedVenue = action.payload;
      state.selectedSeriesData = "Today";
      state.selectedTopSellingSeries = "Today";
    },
    setSelectedSeriesData(state, action) {
      state.selectedSeriesData = action.payload;
    },
    setSelectedTopSellingSeries(state, action) {
      state.selectedTopSellingSeries = action.payload;
    },
    resetFilters(state) {
      state.selectedVenue = "All";
      state.selectedSeriesData = "Today";
      state.selectedTopSellingSeries = "Today";
    },
  },
});

export const {
  startLoading,
  hasError,
  getStatsSuccess,
  setSelectedVenue,
  setSelectedSeriesData,
  resetFilters,
  getTopSellingStatsSuccess,
  setSelectedTopSellingSeries,
} = statSlice.actions;

export default statSlice.reducer;

const getSelectedVenueIds = (selectedVenue) => {
  if (!selectedVenue || selectedVenue === "All") return [];

  const venues = Array.isArray(selectedVenue) ? selectedVenue : [selectedVenue];

  return venues.map((venue) => venue?.id || venue?._id).filter(Boolean);
};

const applyVenueParams = (params, key, selectedVenue) => {
  if (key === "all") return;

  const venueIds = getSelectedVenueIds(selectedVenue);

  if (venueIds.length === 1) {
    params.venueId = venueIds[0];
  } else if (venueIds.length > 1) {
    params.venueIds = venueIds.join(",");
  }
};

export const getStats = (franchise, startDate, endDate, key, selectedVenue) => {
  return async (dispatch) => {
    dispatch(startLoading());

    try {
      const baseURL = `${backendUrl}/franchise/${franchise.id}/venues-stats`;

      const params = {
        startDate,
        endDate,
      };

      applyVenueParams(params, key, selectedVenue);

      const response = await axios.get(baseURL, { params });

      dispatch(getStatsSuccess(response.data));
    } catch (error) {
      console.log("error", error);
      dispatch(hasError(error));
    }
  };
};

export const getStatsForTopSelling = (
  franchise,
  startDate,
  endDate,
  key,
  selectedVenue
) => {
  return async (dispatch) => {
    dispatch(startLoading());

    try {
      const baseURL = `${backendUrl}/franchise/${franchise.id}/getStatsTopItems`;

      const params = {
        startDate,
        endDate,
      };

      applyVenueParams(params, key, selectedVenue);

      const response = await axios.get(baseURL, { params });

      dispatch(getTopSellingStatsSuccess(response.data));
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};